import theme from 'src/libs/styled-components/theme';
import { IconProps } from '..';

export default function IconClose({
  width = 20,
  height = 21,
  color = theme.palette.grayscale600
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ic_close*24">
        <path
          id="Vector"
          d="M16.2 6.0748L14.425 4.2998L10 8.7373L5.57505 4.2998L3.80005 6.0748L8.23755 10.4998L3.80005 14.9248L5.57505 16.6998L10 12.2623L14.425 16.6998L16.2 14.9248L11.7625 10.4998L16.2 6.0748Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
